@let typeKeys = paymentTypeKeys();
<span>
  {{ 'entryFeeCalc.explain.fee1' | translate }}{{ (feeRatio() * 100) | number:'1.0-2' }}
  {{ ('entryFeeCalc.explain.' + typeKeys[type()].explain) | translate }}
  @if (displayFee().entryFeeType === EFeeType.PROPORTIONAL) {
    {{ 'entryFeeCalc.explain.paymentInfo_proportional_addition' | translate }}
  }
</span>
@if (feeVat() > 0) {
  <span>
    {{ 'entryFeeCalc.explain.vat' | translate }}
    {{ feeVat() | price: currencyCode() }}.
  </span>
}
@if (type() === 'REGULAR' && discountRegularDeposit() > 0) {
  <span>
    {{ 'entryFeeCalc.explain.discount1' | translate }}
    {{ (discountRegularDeposit() * 100) | number:'1.0-2' }}
    {{ 'entryFeeCalc.explain.discount2' | translate }}
  </span>
}
<span>
  {{ ('entryFeeCalc.explain.' + typeKeys[type()].paymentInfo) | translate }}{{ typeKeys[type()].code }}).
</span>
